var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sessionbox"},[_c('img',{attrs:{"src":"/static/img/logo-icon.svg"}}),_c('h5',{staticClass:"mb-0 mr-2 text"},[_vm._v("\n    Starting your Nanome session\n    "),_c('div',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.ellipsis))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }